/**
 * English catalog — the SOURCE OF TRUTH for the message shape. `Messages` is
 * derived from this object; every other locale must provide the exact same
 * keys (a missing or extra translation is a compile error, not a runtime
 * fallback). Keep namespaces small and page-scoped.
 */

import { access } from './access'
import { beats } from './beats'
import { common } from './common'
import { errors } from './errors'
import { feedback } from './feedback'
import { flows } from './flows'
import { home } from './home'
import { journey } from './journey'
import { login } from './login'
import { memories } from './memories'
import { newRun } from './newRun'
import { run } from './run'
import { runs } from './runs'
import { shell } from './shell'
import { theater } from './theater'

export const en = {
  common,
  shell,
  login,
  beats,
  journey,
  theater,
  home,
  flows,
  memories,
  access,
  newRun,
  runs,
  run,
  feedback,
  errors
}

export type Messages = typeof en
